// src/pages/asn/formFields/asnTabsFields.js
export const asnDetailsFields = [
  {
    name: "asnNumber",
    label: "ASN Number",
    type: "text",
    required: true,
    autoGenerated: true,
    prefetch: true,
    prefetchFormat: "ASN####",
    readOnly: true,
    hiddenOnCreate: true
  },
  { name: "externalASNReciept", label: "External ASN", type: "text", readOnly: true, },
  
  
  { name: "owner", label: "Owner", type: "partnerLookup", required: true },


  { name: "asnType", label: "ASN Type", type: "select", options: ["Normal", "PO", "Customer Return", "IWT", "PO Return"], required: true, defaultValue: "Normal", },
  // { name: "destinationLocationCode", label: "Destination Location ID", type: "text", required: true },
  //{ name: "destinationLocationName", label: "Destination City", type: "text", required: true },
  { name: "destinationLocationName", label: "Destination City", type: "text" },
  {
    name: "createUsing",
    label: "Create Using",
    type: "select",
    options: [
      { value: 1, label: "SKU ID" },
      { value: 2, label: "PO Number" },
      { value: 3, label: "Blind ASN" }
      // { value: 3, label: "External PO Number" }
    ],
    required: true
  },
  {
    name: "poNumber",
    label: "PO Number",
    type: "text",
    searchable: true,
    conditional: { field: "createUsing", value: 2 } // Updated to match numeric value
  },
  //  { 
  //   name: "externalPoNumber", 
  //   label: "External PO Number", 
  //   type: "text", 
  //   searchable: true, 
  //   conditional: { field: "createUsing", value: 3 } // Updated to match numeric value
  // },
  {
    name: "SKUID",
    label: "SKU ID",
    type: "text",
    searchable: true,
    conditional: { field: "createUsing", value: 1 } // Updated to match numeric value
  },
  // { name: "destinationLocationFilter", label: "Destination Location Filter", type: "text" },
  // { name: "receiptStatus", label: "Receipt Status", type: "select", options: ["New", "Packed", "InProcess", "Delivered", "Pending",], readOnly: true },
  {
    name: "receiptStatus",
    label: "Receipt Status",
    type: "select",
    options: [
      { value: "New", label: "New" },
      { value: "Packed", label: "Packed" },
      { value: "In Transit", label: "In Transit" },
      { value: "Delivered", label: "Delivered" },
      { value: "Pending", label: "Pending" }
    ],
    disabled: true,
    readOnly: true,         // added
    // defaultValue: "New"     // added default
  },
  // { name: "scheduledShipDate", label: "Scheduled Ship Date", type: "date" },
  // { name: "actualShipDate", label: "Actual Ship Date", type: "date" },
  { name: "totalReceivedQty", label: "Total Received Qty", type: "number", readOnly: true },
  { name: "totalExpectedQty", label: "Total Expected Qty", type: "number", readOnly: true },
  { name: "totalWeight", label: "Total Weight", type: "number", readOnly: true },
  { name: "totalVolume", label: "Total Volume ", type: "number", readOnly: true },
  { name: "asnCreatedate", label: "Created Date", type: "date", readOnly: true },

  { name: "createdBy", label: "Created By ", type: "text", readOnly: true },

  { name: "closedDate", label: "Closed Date", type: "date", readOnly: true },
  { name: "grnNumber", label: "GRN", type: "string", readOnly: true },
  { name: "totalShortQty", label: "Total Short Qty", type: "number", readOnly: true },
  { name: "totalExcessQty", label: "Total Excess Qty", type: "number", readOnly: true },
  { name: "damagedQty", label: "Total Damage Qty", type: "number", readOnly: true },
  { name: "totalASNPrice", label: "Total ASN Value", type: "number", readOnly: true },
  { name: "totalPOValue", label: "PO Invoice Value", type: "number", readOnly: true },


  { name: "updatedAt", label: "Updated Date", type: "date", readOnly: true },
  { name: "updatedBy", label: "Updated By", type: "text", readOnly: true }

];


export const itemFields = [
  { name: "lineNumber", label: "Line#" },
  { name: "skuId", label: "SKU ID" },
  { name: "item", label: "Item (sku fallback)" },
  { name: "description", label: "Description" },
  { name: "pack", label: "Pack" },
  { name: "packKey", label: "Pack Key" },
  { name: "lpnNo", label: "LPN No" },
  { name: "batchNum", label: "Batch Num" },
  { name: "manufacturingDate", label: "Manufacturing Date" },
  { name: "expirationDate", label: "Expiration Date" },
  { name: "uom", label: "UOM" },
  { name: "orderQty", label: "Order Qty" },
  { name: "openQty", label: "Open Qty" },
  { name: "receivedQty", label: "Received Qty" },
  { name: "qcRequired", label: "QC Required" },
  { name: "status", label: "Status" },
  { name: "itemweight", label: "Item Weight" },
  { name: "itemcode", label: "Item Volume" },
  // add more item-level fields you use
];
// export const shipFromFields = [
//   { name: "shipFromCode", label: "Source Location ID", type: "text" },
//   { name: "shipFromName", label: "Source Location Name", type: "text" },
//   { name: "shipFromAddress1", label: "Address Line 1", type: "text" },
//   { name: "shipFromAddress2", label: "Address Line 2", type: "text" },
//   { name: "shipFromAddress3", label: "Address Line 3", type: "text" },
//   { name: "shipFromAddress4", label: "Address Line 4", type: "text" },
//   { name: "shipFromAddress5", label: "Address Line 5", type: "text" },
//   { name: "shipFromAddress6", label: "Address Line 6", type: "text" },
//   { name: "city", label: "City", type: "text" },
//   { name: "state", label: "State", type: "text" },
//   { name: "zip", label: "Zip", type: "text" },
//   { name: "isoCountryCode", label: "ISO Country Code", type: "text" },
//   { name: "contact", label: "Contact", type: "text" },
//   { name: "email", label: "Email", type: "email" },
//   { name: "phone", label: "Phone", type: "text" }
// ];


// Supplier (Source)


// ------------------- Add Items (Blind ASN) Fields -------------------
export const addItemsFieldsData = [
  { name: "lineNumber", label: "Line Number (Auto)", type: "text", readOnly: true },
  { name: "item", label: "SKU ID", type: "text", hasSearch: true, required: true },
  { name: "description", label: "Description", type: "text", required: true },
  { name: "pack", label: "Pack", type: "text", defaultValue: "STD" },
  { name: "packKey", label: "Pack Key", type: "text" },
  { name: "lpnNo", label: "LPN No", type: "text" },
  { name: "batchNum", label: "Batch Num", type: "text" },
  { name: "manufacturingDate", label: "Manufacturing Date", type: "date" },
  { name: "expirationDate", label: "Expiration Date", type: "date" },
  { name: "itemcode", label: "Item Volume", type: "text" },
  { name: "itemweight", label: "Item Weight", type: "number" },
  {
    name: "uom",
    label: "UOM",
    type: "select",
    options: [
      { value: "", label: "Select" },
      { value: "EA", label: "EA" },
      { value: "PCS", label: "PCS" },
      { value: "KG", label: "KG" },
      { value: "LBS", label: "LBS" },
      { value: "M", label: "M" },
      { value: "FT", label: "FT" },
    ],
    required: true,
  },
  { name: "orderQty", label: "Order Qty", type: "number", required: true },
  { name: "tolerance", label: "Item SO Tolerance %", type: "number" },
  { name: "qcRequired", label: "QC Required", type: "checkbox" },
  { name: "openqty", label: "Open Qty", type: "text", readOnly: true },
  { name: "receivedqty", label: "Received Qty", type: "text", readOnly: true },
  { name: "status", label: "Status", type: "text", defaultValue: "New", readOnly: true },
];


/**
 * SKU ID (1) and Blind ASN (3) have no PO, so there is no PO supplier to load a
 * Ship From list from. In those modes Ship From also shows a Supplier lookup.
 */
export const isSupplierOnlyShipFrom = (formData) =>
  [1, 3].includes(Number(formData?.createUsing));

/**
 * Field visibility: supports `conditional: { field, value }` (single value),
 * `conditional: { field, values: [...] }`, and `showWhen(formData) => boolean`.
 */
export function isFieldVisible(field, formData = {}) {
  if (typeof field?.showWhen === "function" && !field.showWhen(formData)) return false;
  const c = field?.conditional;
  if (!c) return true;
  const current = formData[c.field];
  if (Array.isArray(c.values)) return c.values.some((v) => v === current || String(v) === String(current));
  return current === c.value || String(current) === String(c.value);
}

export const supplierAddressFieldsASN = [
  // SKU ID / Blind ASN: Supplier lookup (shows the supplier ID). Selecting one
  // fills the Ship From fields below and enables the Ship From Name lookup
  // for that supplier. Hidden for PO Number, where the PO supplies the supplier.
  { name: "supplierId", label: "Supplier", type: "supplierLookup", required: true, showWhen: isSupplierOnlyShipFrom },
  { name: "supplierName", label: "Ship From Name", type: "shipFromLookup", required: true },
  { name: "supplierAddressLine1", label: "Address Line 1", type: "text", required: true },
  { name: "supplierAddressLine2", label: "Address Line 2", type: "text" },
  { name: "supplierAddressLine3", label: "Address Line 3", type: "text" },
  { name: "supplierAddressLine4", label: "Address Line 4", type: "text" },
  { name: "supplierCity", label: "City", type: "text", required: true },
  { name: "supplierState", label: "State", type: "text", required: true },
  { name: "supplierCountry", label: "Country", type: "text", required: true },
  { name: "supplierReference", label: "Reference", type: "text" },
  { name: "supplierContact", label: "Contact", type: "text" },
  { name: "supplierEmail", label: "Email", type: "email" },
];


export const buyerAddressFieldsASN = [
  // Own key so it does not overwrite the header `owner` (partner_id).
  { name: "buyerName", label: "Name", type: "customerLookup", required: true },
  { name: "buyerAddressLine1", label: "Address Line 1", type: "text", required: true },
  { name: "buyerAddressLine2", label: "Address Line 2", type: "text" },
  { name: "buyerAddressLine3", label: "Address Line 3", type: "text" },
  { name: "buyerAddressLine4", label: "Address Line 4", type: "text" },
  { name: "buyerCity", label: "City", type: "text", required: true },
  { name: "buyerState", label: "State", type: "text", required: true },
  { name: "buyerCountry", label: "Country", type: "text", required: true },
  { name: "buyerReference", label: "Reference", type: "text" },
  { name: "buyerContact", label: "Contact", type: "text" },
  { name: "buyerEmail", label: "Email", type: "email" },
];



export const carrierFields = [
  { name: "carrierName", label: "Carrier Name", type: "text" },
  { name: "carrierAddressLine1", label: "Carrier Address Line 1", type: "text" },
  { name: "carrierAddressLine2", label: "Carrier Address Line 2", type: "text" },
  { name: "carrierCity", label: "Carrier City", type: "text" },
  { name: "carrierState", label: "Carrier State", type: "text" },
  { name: "carrierCountry", label: "Carrier Country", type: "text" },
  { name: "carrierContact", label: "Carrier Contact", type: "text" },
  { name: "carrierEmail", label: "Carrier Email", type: "email" },
];


export const loadFields = [
  { name: "loadNumber", label: "Vehicle Number", type: "text" },
  { name: "truckDetails", label: "Vehicle Details", type: "text", },
  { name: "driverDetails", label: "Driver Details", type: "text" },
  //  {  name: "expectedDepartureDate", label: "Expected Departure Date", type: "date" },
  { name: "actualDepartureDate", label: "Actual Departure Date", type: "date" },
  { name: "expectedArrivalDate", label: "Expected Arrival Date", type: "date" },
  // { name: "expecteddepartureDate", label: "Expected Departure Date", type: "date" },
  { name: "actualArrivalDate", label: "Actual Arrival Date", type: "date" },
  // { name: "termsOfPayment", label: "Terms of Payment", type: "text" },

];

export const userDefinedFields = [
  // ---- Text UDFs ----
  { name: "asnReceiptTextUdf1", label: "ASN Receipt Text UDF 1", type: "text" },
  { name: "asnReceiptTextUdf2", label: "ASN Receipt Text UDF 2", type: "text" },
  { name: "asnReceiptTextUdf3", label: "ASN Receipt Text UDF 3", type: "text" },

  // ---- Numeric UDFs ----
  { name: "asnReceiptNumericUdf1", label: "ASN Receipt Numeric UDF 1", type: "number" },
  { name: "asnReceiptNumericUdf2", label: "ASN Receipt Numeric UDF 2", type: "number" },
  { name: "asnReceiptNumericUdf3", label: "ASN Receipt Numeric UDF 3", type: "number" },

  // ---- Date UDFs ----
  { name: "asnReceiptDateUdf1", label: "ASN Receipt Date UDF 1", type: "date" },
  { name: "asnReceiptDateUdf2", label: "ASN Receipt Date UDF 2", type: "date" },
  { name: "asnReceiptDateUdf3", label: "ASN Receipt Date UDF 3", type: "date" },
];


export const invoiceFields = [
  {
    name: "invoiceNumber",
    label: "Invoice Number",
    type: "text",
    required: false
  },
  { name: "invoiceDate", label: "Invoice Date", type: "date", required: false },
  {
    name: "invoiceType",
    label: "Invoice Type",
    type: "select",
    options: ["Standard", "Credit Note", "Debit Note", "Pro Forma", "Commercial", "Tax Invoice"],
    required: false
  },
  {
    name: "invoiceAmount",
    label: "Invoice Amount",
    type: "number",
    required: false,
    step: "0.01",
    min: "0"
  },
  {
    name: "paymentTerms",
    label: "Payment Terms",
    type: "select",
    options: ["30 Days", "45 Days", "60 Days", "Prepaid", "On Delivery"],
    required: false
  },
  {
    name: "invoiceUpload",
    label: "Invoice Upload",
    type: "file",
    accept: ".pdf,.jpg,.jpeg,.png,.doc,.docx",
    required: false
  }
];

// Helper to build default (null) values for all fields
export const allAsnFieldGroups = [
  asnDetailsFields,
  carrierFields,
  loadFields,
  userDefinedFields,
  supplierAddressFieldsASN,
  buyerAddressFieldsASN,
  invoiceFields
];

export function buildDefaultASNFormData() {
  const defaults = {};
  allAsnFieldGroups.forEach(group =>
    group.forEach(f => {
      if (!(f.name in defaults)) defaults[f.name] = null;
    })
  );

  // Remove automatic default selection for createUsing - user must select manually
  // if (defaults.createUsing == null) defaults.createUsing = 1;

  // Set default receipt status
  if (defaults.receiptStatus == null) defaults.receiptStatus = "New";
  return defaults;
}

// Add helper function to validate table data structure
export function validateTableData(tableData) {
  if (!tableData || typeof tableData !== 'object') return false;

  const validEntries = Object.entries(tableData)
    .filter(([key, val]) => {
      return key !== '__lastAddedTable' &&
        key !== '__userTriggered' &&
        Array.isArray(val) &&
        val.length > 0 &&
        val.some(item => item && (item.skuId || item.item));
    });

  return validEntries.length > 0;
}
